export default function Cookie() {
  return (
    <div className="max-w-3xl mx-auto px-5 py-10 md:py-16">
      <div className="text-xs tracking-widest uppercase text-primary">Informativa</div>
      <h1 className="font-display text-3xl md:text-5xl mt-2">Cookie Policy</h1>
      <p className="text-foreground/70 mt-3">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT")}</p>

      <div className="mt-8 space-y-6 text-[15px] leading-7 text-foreground/80">
        <section>
          <h2 className="font-display text-2xl text-foreground">Cos'è un cookie</h2>
          <p>Un cookie è un piccolo file di testo salvato nel tuo browser che permette al sito di riconoscerti tra una visita e l'altra.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl text-foreground">Cookie utilizzati da questo sito</h2>
          <p>Usiamo esclusivamente <b>cookie tecnici e di sessione</b>, indispensabili al funzionamento dell'applicazione. Non è richiesto il tuo consenso preventivo per questi cookie.</p>
          <div className="mt-4 rounded-md border border-border overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-secondary text-left">
                <tr><th className="p-3">Nome</th><th className="p-3">Finalità</th><th className="p-3">Durata</th></tr>
              </thead>
              <tbody>
                <tr className="border-t border-border"><td className="p-3 font-mono">maurizi_token</td><td className="p-3">Mantiene la sessione di accesso all'area riservata.</td><td className="p-3">30 giorni</td></tr>
                <tr className="border-t border-border"><td className="p-3 font-mono">cookie_consent</td><td className="p-3">Memorizza la tua scelta sul banner cookie.</td><td className="p-3">180 giorni</td></tr>
              </tbody>
            </table>
          </div>
        </section>
        <section>
          <h2 className="font-display text-2xl text-foreground">Cookie di terze parti</h2>
          <p>Non utilizziamo cookie di profilazione né di terze parti (Google Analytics, Facebook Pixel, ecc.).</p>
        </section>
        <section>
          <h2 className="font-display text-2xl text-foreground">Come disabilitare i cookie</h2>
          <p>Puoi in qualsiasi momento eliminare i cookie dalle impostazioni del tuo browser. Disabilitando i cookie tecnici l'accesso all'area riservata potrebbe non funzionare.</p>
        </section>
      </div>
    </div>
  );
}
